export class BackendError extends Error {
  error: string;
  override message: string;
  localizedMessage: string | null | undefined;
  path: string;
  status: number;
  timestamp: string;
  trace: string;

  constructor(
    error: string,
    message: string,
    path: string,
    status: number,
    timestamp: string,
    trace: string,
    localizedMessage: string | null | undefined
  ) {
    super(error);
    this.error = error;
    this.message = message;
    this.path = path;
    this.status = status;
    this.timestamp = timestamp;
    this.trace = trace;
    this.localizedMessage = localizedMessage
  }

  static [Symbol.hasInstance](obj: unknown): boolean {
    return !!obj
      && typeof obj === 'object'
      && 'error' in obj
      && 'message' in obj
      && 'path' in obj
      && 'status' in obj
      && 'timestamp' in obj;
  }
}

export type ValidationErrorArgument = {
  "codes": string[],
  "arguments": string[],
  "defaultMessage": string,
  "code": string
}

export type ValidationError = {
  "codes": string[],
  "arguments": [ValidationErrorArgument | string | number],
  "defaultMessage": string,
  "objectName": string,
  "field": string,
  "rejectedValue": string,
  "bindingFailure": boolean,
  "code": string
}

export class BackendValidationError extends BackendError {
  errors: ValidationError[];

  constructor(
    error: string,
    message: string,
    path: string,
    status: number,
    timestamp: string,
    trace: string,
    localizedMessage: string | null | undefined,
    errors: ValidationError[]
  ) {
    super(error, message, path, status, timestamp, trace, localizedMessage);
    this.errors = errors;
  }

  static [Symbol.hasInstance](obj: unknown): boolean {
    return !!obj && typeof obj === 'object' && BackendError[Symbol.hasInstance](obj) && 'errors' in obj;
  }
}

